const url = `https://eidim-media2.s3-us-west-1.amazonaws.com/images/gallery/`

export const GALLERY = [
  {
    src: `${url}eidim-1.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-2.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-3.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-4.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-5.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-6.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-7.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-8.jpg`,
    head: 'EIDIM',
  },
  {
    src: `${url}eidim-9.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-10.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-11.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-12.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-13.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-14.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-15.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-16.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-17.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-18.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-19.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-20.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-21.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-22.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-23.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-24.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-25.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-27.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-28.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-29.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-30.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-31.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-32.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-33.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-34.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-35.jpg`,
    head: 'EIDIM',
  },
  {
    src: `${url}eidim-36.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-37.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-38.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-39.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-40.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-41.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-42.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-43.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-44.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-45.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-46.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-47.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-48.jpg`,
    head: 'EIDIM',
  },

  {
    src: `${url}eidim-49.jpg`,
    head: 'EIDIM',
  },

]